import countriesJson from '~/data/countries.json'
import type { ShippingCountryCode } from '~/schemas/country'

export const getCountryName = (countryCode: ShippingCountryCode) => {
  return (
    countriesJson as {
      [code: string]: string
    }
  )[countryCode]
}

export const getSortedCountryList = (countryCodes: ShippingCountryCode[]) => {
  return countryCodes
    .map((countryCode) => ({
      value: countryCode,
      label: getCountryName(countryCode) || '',
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}
